$bog_ainews_app $mol_book2_catalog
	Placeholder null
	Menu_logo $mol_icon_newspaper
	menu_title @ \VibeNews - your favorites 
	menu_tools /
		<= Lights $mol_lights_toggle
	plugins /
		<= Theme $bog_theme_auto
			themes /
				\$mol_theme_ainews_light
				\$mol_theme_ainews_dark
			theme_light \$mol_theme_ainews_light
			theme_dark \$mol_theme_ainews_dark
	spreads *
		\
			- <= FAQ $bog_ainews_app_faq
			<= Feed $bog_ainews_app_feed
		- feed <= Feed $bog_ainews_app_feed
		favorite <= Favorite $bog_ainews_app_favorites
		sources <= Sources $bog_ainews_app_sources
		filters <= Filters $bog_ainews_app_filters
		settings <= Settings $bog_ainews_app_settings
		features <= Features $mol_page
			title @ \Features list
			body /
				<= Feat_1 $mol_paragraph title @ \* Specify your own RSS feeds
				<= Feat_2 $mol_paragraph title @ \* Choose from ready-made presets
